/* Velvinate Diwali Edit: reveal-on-scroll, offer expiry, countdowns, ticker pause. No dependencies. */
(function () {
  var d = document, html = d.documentElement;
  html.classList.add('vd-ready');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  function reveal(root) {
    var els = (root || d).querySelectorAll('[data-vd-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Anything carrying data-vd-until (ISO date) is hidden once that moment passes, so cached pages never show an expired offer. */
  function expire() {
    if (design) return;
    var now = Date.now();
    d.querySelectorAll('[data-vd-until]').forEach(function (e) {
      var u = Date.parse(e.getAttribute('data-vd-until'));
      if (u && now > u) { e.hidden = true; e.setAttribute('aria-hidden', 'true'); }
    });
  }

  function countdowns() {
    d.querySelectorAll('[data-vd-countdown]').forEach(function (c) {
      if (c._vdTimer) return;
      var end = Date.parse(c.getAttribute('data-vd-countdown'));
      if (!end) return;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var q = function (k) { return c.querySelector('[data-' + k + ']'); };
      function tick() {
        var t = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (t === 0) { clearInterval(c._vdTimer); expire(); }
        q('d').textContent = pad(Math.floor(t / 86400)); t %= 86400;
        q('h').textContent = pad(Math.floor(t / 3600)); t %= 3600;
        q('m').textContent = pad(Math.floor(t / 60));
        q('s').textContent = pad(t % 60);
      }
      tick();
      c._vdTimer = setInterval(tick, 1000);
    });
  }

  function pauses() {
    d.querySelectorAll('[data-vd-pause]').forEach(function (b) {
      if (b._vd) return; b._vd = 1;
      var host = b.closest('[data-vd-marquee]');
      if (!host) return;
      b.addEventListener('click', function () {
        var p = host.classList.toggle('is-paused');
        b.setAttribute('aria-pressed', p ? 'true' : 'false');
        b.setAttribute('aria-label', p ? 'Play announcements' : 'Pause announcements');
      });
    });
  }

  function init(root) { reveal(root); expire(); countdowns(); pauses(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
